import React from 'react';
import { useFormState } from 'react-final-form';

import { SecondaryButton } from '@common/button';
import { useScopedTranslation } from '@common/utils/hooks/useScopedTranslation';
import { OfficesQuery_offices as OfficeType } from '@typings/api';

import Office from './Office';
import { OfficeSkeleton } from './Skeleton';

interface Props {
  hasAddress?: boolean;
  hasExactMatch?: boolean;
  loading: boolean;
  offices: Array<OfficeType>;
  onSelectOffice: (office: OfficeType) => void;
  onShowMoreOffices?: () => void;
}

export default function Offices(props: Props) {
  const { hasExactMatch, loading, offices, onSelectOffice, onShowMoreOffices } =
    props;

  const { t } = useScopedTranslation();
  const {
    values: { offices: selectedOffices = [], address },
  } = useFormState();

  if (loading) {
    return <OfficeSkeleton />;
  }

  if (!address) {
    return null;
  }

  if (offices.length === 0) {
    return <p>{t('main_form.offices.not_found')}</p>;
  }

  return (
    <>
      <div>
        {offices.map((office) => (
          <Office
            hasExactMatch={hasExactMatch}
            isSelected={selectedOffices.some(
              (selectedOffice: OfficeType) => selectedOffice.id === office.id,
            )}
            key={office.id}
            office={office}
            onSelect={onSelectOffice}
          />
        ))}
      </div>
      {onShowMoreOffices !== undefined && (
        <div className="mt-4">
          <SecondaryButton onClick={onShowMoreOffices} type="button">
            {t('main_form.offices.load_more')}
          </SecondaryButton>
        </div>
      )}
    </>
  );
}
